module.exports = __webpack_public_path__ + "static/img/logo.e1559cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icon/logo.jpg
// module id = Pe+9
// module chunks = 0